import { DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  signal,
  viewChild,
} from '@angular/core';
import { MibButtonComponent, MibIconsModule } from '@medinbox/angular';
import { MarkdownComponent } from 'ngx-markdown';
import { MibLogo } from '../../mib-header/mib-logo';

interface Tab {
  title: string;
  file: string;
}

@Component({
  selector: 'mai-terms-conditions',
  imports: [MibLogo, MibButtonComponent, MibIconsModule, MarkdownComponent],
  templateUrl: './terms-conditions.dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TermsConditionsDialog {
  readonly dialogRef = inject(DialogRef);

  readonly tabs = [
    {
      title: 'Terms of service',
      file: 'terms-conditions/Terms_of_Service.md',
    },
    {
      title: 'License Agreement',
      file: 'terms-conditions/Global_Software_License.md',
    },
    {
      title: 'Business Associate & Data Processing Agreement',
      file: 'terms-conditions/Global_BAA_Medinbox.md',
    },
  ];
  readonly currentTab = signal(this.tabs[0].file);
  readonly tabContent = viewChild.required<ElementRef<HTMLDivElement>>('tabContent');

  onError(event: unknown): void {
    console.error('Error while loading terms and conditions:', event);
  }

  selectTab(tab: Tab): void {
    this.currentTab.set(tab.file);
    this.tabContent().nativeElement.scrollTo({ top: 0 });
  }
}
